import React from "react";
import { Box, Typography } from "@mui/material";
import { ActiveResponse } from "../../../../../services/decisionFlow";
import { WizardShell } from "../../../../../components/ui";
import { TOPIC_STEPS } from "../../wizard-steps";
import { useActivesSelect } from "./use-actives-select";
import SelectableOptionRow from "../components/SelectableOptionRow";
import SelectionChip from "../../components/selection-chip";

type Props = {
    onFinish: (actives: ActiveResponse[]) => void;
    onBack: () => void;
    actives: ActiveResponse[];
};

export const Actives: React.FC<Props> = ({ onFinish, onBack, actives }) => {
    const { checkableValue, selectedCount, handleContinue, handleOnChange, clearAll } = useActivesSelect(actives, onFinish);

    return (
        <WizardShell
            steps={TOPIC_STEPS as unknown as string[]}
            activeIndex={2}
            onBack={onBack}
            onNext={handleContinue}
            nextLabel="Continuar"
            nextDisabled={selectedCount === 0}
        >
            {/* Cabeçalho */}
            <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "12px", mb: "4px" }}>
                <Typography sx={{ fontFamily: "'DM Serif Display', serif", fontSize: 24, fontWeight: 400, color: "text.primary" }}>
                    Classes de Ativos
                </Typography>
                <SelectionChip count={selectedCount} onClear={clearAll} />
            </Box>
            <Typography sx={{ fontSize: 13.5, color: "text.secondary", mb: "20px" }}>
                Selecione as classes de ativos para a formulação.
            </Typography>

            {/* Lista re-skinada */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                {checkableValue.map((item, index) => (
                    <SelectableOptionRow
                        key={item.value.id ?? index}
                        label={item.value.name}
                        selected={item.isSelected}
                        onClick={() => handleOnChange(item.value, !item.isSelected)}
                    />
                ))}
            </Box>
        </WizardShell>
    );
};
